import React from 'react';
import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Assignment = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Assignment</Text>
      <Text style={styles.listItem}>
        This Agreement is binding upon the parties, their heirs, personal
        representatives, guardians and successors, and to the extent assignable,
        on the assigns of the parties hereto. Buyer will not transfer or assign
        this Agreement without the written consent of Seller unless otherwise
        stated in this Agreement. Assignment of this Agreement may result in
        additional transfer taxes.
      </Text>
    </View>
  );
};

export default Assignment;
